// 2026-07-02 US-003
import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import {
  BatchDetailResponse,
  GetRecipientsResponse,
  HistoryItem,
  SendResponse,
} from 'common/models/BulkNotificationTypes';
import { OperationStatus } from 'store/rootTypes';

const name = 'BulkNotifications';

interface IBulkNotificationsState {
  submitStatus: OperationStatus;
  RecipientsResponse?: GetRecipientsResponse;
  SendResponse?: SendResponse;
  History: HistoryItem[];
  BatchDetail?: BatchDetailResponse;
}

const initialState: IBulkNotificationsState = {
  submitStatus: OperationStatus.idle,
  RecipientsResponse: undefined,
  SendResponse: undefined,
  History: [],
  BatchDetail: undefined,
};

export const BulkNotificationsSlice = createSlice({
  name,
  initialState,
  reducers: {
    resetState: () => {
      return initialState;
    },
    SetRecipientsResponse: (state, action: PayloadAction<GetRecipientsResponse | undefined>) => {
      state.RecipientsResponse = action.payload;
    },
    SetSendResponse: (state, action: PayloadAction<SendResponse | undefined>) => {
      state.SendResponse = action.payload;
    },
    SetHistory: (state, action: PayloadAction<HistoryItem[]>) => {
      state.History = action.payload;
    },
    SetBatchDetail: (state, action: PayloadAction<BatchDetailResponse | undefined>) => {
      state.BatchDetail = action.payload;
    },
    submitStatus: (state) => handlePendingSubmitAction(state),
    submitStatusRejected: (state, action: PayloadAction<string>) => handleSubmitRejection(state, action),
    submitStatusSucceeded: (state) => {
      state.submitStatus = OperationStatus.succeeded;
    },
    resetSubmitStatus: (state) => {
      state.submitStatus = OperationStatus.idle;
    },
  },
});

const handlePendingSubmitAction = (state) => {
  state.submitStatus = OperationStatus.pending;
};

const handleSubmitRejection = (state, action: PayloadAction<string>) => {
  state.submitStatus = OperationStatus.failed;
  console.error(action.payload);
};

export const { actions: BulkNotificationsActions } = BulkNotificationsSlice;

export default BulkNotificationsSlice.reducer;
